import { Container, ContainerActionsProps } from '@chronosphereio/chrono-ui';

export interface VizContainerActionsProps extends Omit<ContainerActionsProps, 'variant'> {}

/**
 * Optional component used to render actions on `VizContainer` without a header. This component should be included as
 * the first child of `VizContainer.Root` for it to work properly.
 *
 * When a `VizContainer.Header` is used, the actions are automatically managed by the header and this component is not
 * needed.
 *
 * It extends from the chrono-ui `Container.Actions` component and shares similar props and behavior, when possible,
 * for consistency.
 */
export const VizContainerActions = ({ ...containerProps }: VizContainerActionsProps) => {
  return <Container.Actions {...containerProps} />;
};
